import { render, staticRenderFns } from "./MoveStep.vue?vue&type=template&id=6ca345ec&scoped=true&"
import script from "./MoveStep.vue?vue&type=script&lang=js&"
export * from "./MoveStep.vue?vue&type=script&lang=js&"
import style0 from "./MoveStep.vue?vue&type=style&index=0&id=6ca345ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca345ec",
  null
  
)

/* custom blocks */
import block0 from "./MoveStep.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports